/**
 * Source-backed close-detail treatment for the covered Gelezinio Vilko road.
 *
 * The municipality's 2022 repair study shows exposed precast wall panels,
 * longitudinal soffit beams, cable trays, warm wall-mounted luminaires and a
 * narrow drainage curb. These values keep that construction language legible
 * in the low-detail miniature without changing the sourced road or collision.
 *
 * https://vilnius.lt/naujienos/projektuotojai-pristatys-gelezinio-vilko-gatves-tunelio-remonto-projekta
 */
export const GELEZINIO_VILKO_TUNNEL_ART = Object.freeze({
  passageIdPrefix: "gelezinio-vilko-tunnel-",
  portalFrameDepthM: 0.62,
  portalPierWidthM: 0.46,
  portalLintelHeightM: 0.42,
  wallPanelLengthM: 4.2,
  wallJointWidthM: 0.055,
  wallJointDepthM: 0.028,
  horizontalJointHeightM: 2.15,
  horizontalJointWidthM: 0.045,
  soffitBeamSpacingM: 1.05,
  soffitBeamWidthM: 0.16,
  soffitBeamDropM: 0.2,
  cableTrayWidthM: 0.16,
  cableTrayHeightM: 0.1,
  cableTrayDropM: 0.72,
  luminaireSpacingM: 6.4,
  luminaireWidthM: 0.09,
  luminaireHeightM: 0.27,
  luminaireLengthM: 0.66,
  luminaireDropM: 0.58,
  drainageCurbWidthM: 0.32,
  drainageCurbHeightM: 0.12,
  dampBandHeightM: 0.48,
});
